export default __webpack_public_path__ + "static/5-safety-tips-when-connecting-to-wifi-overseas-7094b9bd2db4c0eb55185a0426775639.jpg";